import axios from "axios";

export const NetworkingMixin = {
    data() {
        return {
            api: null,
            bootstrapped: false,
            data: [],
            error: null,
            currentQuery: null,
        }
    },
    computed: {
        querying() {
            return this.currentQuery !== null;
        },
        isEmpty() {
            return !this.error && !this.data.length;
        },
    },
    methods: {
        query() {
            if (!this.api) {
                return null;
            }

            if (!this.validateQuery()) {
                this.handleQueryValidationError();
            }

            this.error = null;
            let params = this.transformRequestParams(this.state, this);
            this.currentQuery = axios.get(this.api, {params: params})
                .then(this.handleQueryResponse)
                .catch(this.handleQueryError).finally(() => {
                    this.currentQuery = null;
                })
        },
        validateQuery() {
            return true;
        },
        handleQueryResponse(response) {
            this.data = this.transformResponseData(response.data);

            this.bootstrapped = true;
        },
        handleQueryError(error) {
            console.error(error);
            this.error = error.response;

            this.bootstrapped = true;
        },
        handleQueryValidationError() {

        },
        transformRequestParams(params, vm) {
            return params;
        },
        transformResponseData(response) {
            return response.data || [];
        },
        isEqual(a, b) {
            return a == b || (Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val,i) => val == b[i]));
        }
    },
    watch: {
        api() {
            this.query();
        }
    },
    mounted() {
        this.query();
    },
};

export default NetworkingMixin;
